import { get, map } from 'lodash/fp';
import uuid from 'uuid/v4';
import axios from './axios';

const siteMap = {
  3: 'BDC',
  11: 'THD',
};

const serviceTypeMap = {
  I: 'Installation',
  M: 'Measurement',
};

export default (
  jobUid,
  serviceType,
  receiveTexts,
  retail,
  cost,
  internalUserName,
  customer,
  address,
) => axios.post(
  '/backfill/book-job',
  {
    jobUid,
    serviceType: serviceTypeMap[serviceType],
    dateCreated: new Date().toISOString(),
    receiveTexts,
    retail,
    cost,
    internalUserName,
    customer: {
      firstName: customer.firstName,
      lastName: customer.lastName,
      uid: customer.id,
      emailAddress: customer.email,
      phoneNumbers: map('number')(customer.phones),
    },
    address: {
      ...address,
      uid: uuid(),
    },
    siteCode: siteMap[window.globalConfig.siteId],
  },
)
  .then(get('data'));
